import React from "react";
import PropTypes from 'prop-types';

export default class Youtube extends React.PureComponent
{
    static propTypes = {
        source: PropTypes.string,
    };

    constructor(props) {
        super(props);
        this.state = {
            source: this.props.source,
        };
    }

    render() {
        if (this.state['source'] === undefined || this.state['source'] == null) {
            return null;
        }
        let youtube = this.getYoutubeSrc(this.state['source']);
        if (youtube === null) {
            return null;
        }
        return (
            <div className="details-section embedded-video">
                <div className={'iframeWrapper'}>
                    <iframe
                        className={ 'ytIframe'}
                        src={youtube}
                        frameBorder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen>
                    </iframe>
                </div>
            </div>
        )
    }

    getYoutubeSrc = (youtube) => {
        let src = this.getYoutubeID(youtube);
        return src === null ? null : '//www.youtube.com/embed/'+src;
    };


    getYoutubeID = (url) => {
        let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        let match = url.match(regExp);

        if (match && match[2].length === 11) {
            return match[2];
        } else {
            return null;
        }
    }
}
